<script lang="ts">
	import { triggerContextMenuWithGenerator, type ContextMenuOptions } from "context-menu"
	import { DataHandlerCalibration, type SnapshotRawData } from "luxedo-data"
	import { LuxedoRPC } from "luxedo-rpc"
	import { downloadCalImages } from "../../../modules/CalUtil"

	interface Props {
		snapshot: SnapshotRawData
		isSelected: boolean
		onSelectToggle: (doSelect: boolean) => void
	}

	let { snapshot, isSelected, onSelectToggle }: Props = $props()

	async function triggerDownload(snapshot: SnapshotRawData) {
		const data = await LuxedoRPC.api.admin.tracked_cali_bundle_down([snapshot.cal_id])
		const calData = data[snapshot.cal_id]

		downloadCalImages(calData)
	}

	function getContextOpts() {
		const opts: ContextMenuOptions = []

		opts.push({
			title: "Download cal images",
			onClick: () => triggerDownload(snapshot),
		})

		return opts
	}
</script>

<div
	class="snapshot-instance"
	class:selected={isSelected}
	onclick={() => onSelectToggle(!isSelected)}
	oncontextmenu={triggerContextMenuWithGenerator(getContextOpts)}
>
	<img src={snapshot.src} alt={`Snapshot #${snapshot.id}`} />
	<div class="checkbox-container">
		<label class="custom-checkbox">
			<input
				type="checkbox"
				checked={isSelected}
				onchange={(e) => onSelectToggle(e.currentTarget.checked)}
			/>
			<span class="checkmark"></span>
		</label>
	</div>
</div>

<style>
	.snapshot-instance {
		position: relative;
		display: inline-block;
		margin: 1rem;
		border: 2px solid transparent;
		border-radius: 0.5rem;
		overflow: hidden;
		cursor: pointer;
		transition:
			border-color 0.2s ease,
			box-shadow 0.2s ease;
		max-width: 300px;
	}

	.snapshot-instance:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	}

	.snapshot-instance.selected {
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
	}

	.snapshot-instance img {
		display: block;
		width: 100%;
		height: auto;
		border-radius: 0.25rem;
		object-fit: contain;
	}

	.checkbox-container {
		pointer-events: none;

		position: absolute;
		top: 0.5rem;
		right: 0.5rem;
	}

	/* Custom checkbox */
	.custom-checkbox {
		position: relative;
		display: inline-block;
		width: 24px;
		height: 24px;
	}

	.custom-checkbox input[type="checkbox"] {
		opacity: 0;
		width: 0;
		height: 0;
		position: absolute;
	}

	.checkmark {
		position: absolute;
		top: 0;
		left: 0;
		height: 24px;
		width: 24px;
		background-color: white;
		border: 2px solid #3b82f6;
		border-radius: 0.375rem;
		transition: background-color 0.2s;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
	}

	.custom-checkbox input:checked + .checkmark {
		background-color: #3b82f6;
	}

	.checkmark::after {
		content: "";
		position: absolute;
		display: none;
		left: 6px;
		top: 2px;
		width: 6px;
		height: 12px;
		border: solid white;
		border-width: 0 2px 2px 0;
		transform: rotate(45deg);
	}

	.custom-checkbox input:checked + .checkmark::after {
		display: block;
	}
</style>
